import React from 'react';

const IcCopy = ({ size = 17, ...props }) => (
  <svg width={size} height={size} {...props} viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.91663 4.18815V4.18815C9.91663 2.81895 8.80667 1.70898 7.43746 1.70898H4.41663C2.75977 1.70898 1.41663 3.05213 1.41663 4.70899V9.19708C1.41663 10.5383 2.50393 11.6257 3.8452 11.6257V11.6257" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <rect x="7.08337" y="7.375" width="8.5" height="9.91667" rx="3" stroke="currentColor" strokeWidth="2"/>
  </svg>
)

export default IcCopy;